import { createSlice } from "@reduxjs/toolkit";
import { Pagination } from "../../../utils/api";
import { User } from "../../users/store/slice";

type InitialState = {
  data: User[];
  meta: Pagination | null;
  isLoading: boolean;
  isCreating: boolean;
  isUpdating: boolean;
  retryingUserId: number | null;
  isRemoving: boolean;
  isRestoring: boolean;
  editableIndex: number | undefined;
  search: string;
  isUnassignLoading: boolean;
};

const initialState: InitialState = {
  data: [],
  meta: null,
  isLoading: false,
  isCreating: false,
  isUpdating: false,
  retryingUserId: null,
  isRemoving: false,
  isRestoring: false,
  editableIndex: undefined,
  search: "",
  isUnassignLoading: false,
};

const userPageSlice = createSlice({
  name: "userPageSlice",
  initialState,
  reducers: {
    fetchData: (state) => {
      state.data = [];
      state.meta = null;
      state.isLoading = true;
    },
    loadMore: (state) => {
      state.isLoading = true;

      if (state.meta) {
        state.meta.current_page++;
      }
    },
    create: (state, action) => {
      state.isCreating = true;
    },
    update: (state, action) => {
      state.isUpdating = true;
    },
    remove: (state, action) => {
      state.isRemoving = true;
    },
    restore: (state, action) => {
      state.isRestoring = true;
    },
    setData: (state, action) => {
      const { data, meta } = action.payload;

      state.data = data;
      state.meta = meta;
    },
    addData: (state, action) => {
      const { data, meta } = action.payload;

      state.data = [...state.data, ...data];
      state.meta = meta;
    },
    addUser: (state, action) => {
      state.data = [action.payload, ...state.data];
    },
    removeUser: (state) => {
      state.data.shift();
    },
    updateUser: (state, action) => {
      const updatedUser: User = action.payload;

      const index = state.data.findIndex((user) => user.id === updatedUser.id);

      if (index !== -1) {
        state.data[index] = updatedUser;
      }
    },
    setIsLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setIsCreating: (state, action) => {
      state.isCreating = action.payload;
    },
    setIsUpdating: (state, action) => {
      state.isUpdating = action.payload;
    },
    setIsRemoving: (state, action) => {
      state.isRemoving = action.payload;
    },
    setIsRestoring: (state, action) => {
      state.isRestoring = action.payload;
    },
    setEditableIndex: (state, action) => {
      state.editableIndex = action.payload;
    },
    setSearch: (state, action) => {
      state.search = action.payload;
      state.data = [];
      state.isLoading = true;
      state.meta = null;
    },
    retryInvite: (state, action) => {
      state.retryingUserId = action.payload;
    },
    setRetryingUserId: (state, action) => {
      state.retryingUserId = action.payload;
    },
    unassignBookings: (state, action) => {
      state.isUnassignLoading = true;
    },
    reset: () => initialState,
  },
});

export default userPageSlice;
